import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Modal, Badge } from 'react-bootstrap';
import { FaEye, FaLaptop, FaPalette, FaStar } from 'react-icons/fa';
import Template1 from './Template1';
import Template2 from './Template2';
import Template3 from './Template3';
import Template4 from './Template4';

import template1Thumbnail from './templete-images/template1.jpg';
import template2Thumbnail from './templete-images/template2.jpg';
import template3Thumbnail from './templete-images/template3.jpg';
import template4Thumbnail from './templete-images/template4.jpg';
import sampleImage from './templete-images/sample-image.jpg';
import './styles/Website-Templates.css';

const WebsiteTemplates = () => {
    const [selectedTemplate, setSelectedTemplate] = useState(null);

    const dummyEvent = {
        event_title: "Sample Wedding",
        event_date: new Date(),
        description: "Sample wedding description",
        wallpaper: [{ md_photo: sampleImage }]
    };

    const templates = [
        {
            id: 1,
            name: "Gold Luxury Wedding",
            tag: "Classic Gold",
            category: "Invitation & RSVP",
            component: <Template1 event={dummyEvent} />,
            image: template1Thumbnail
        },
        {
            id: 2,
            name: "Save The Date Romance",
            tag: "Modern Minimal",
            category: "Save The Date",
            component: <Template2 event={dummyEvent} />,
            image: template2Thumbnail
        },
        {
            id: 3,
            name: "Royal Blue Countdown",
            tag: "Royal Theme",
            category: "Countdown & Gallery",
            component: <Template3 event={dummyEvent} />,
            image: template3Thumbnail
        },
        {
            id: 4,
            name: "Floral Elegance",
            tag: "Floral Grace",
            category: "Story & Program",
            component: <Template4 event={dummyEvent} />,
            image: template4Thumbnail
        }
    ];

    return (
        <Container fluid className="templates-container py-4 px-2 px-md-4">
            {/* Title Header */}
            <div className="text-center mb-4">
                <h1 className="stylish-heading mb-1" style={{ color: '#4169e1' }}>
                    Website Templates
                </h1>
                <p className="text-muted small mb-0">
                </p> 
            </div>

            <Row className="g-4">
                {templates.map((template) => (
                    <Col lg={4} md={6} xs={12} key={template.id}>
                        <Card className="template-card h-100 border-0 shadow-sm rounded-4 overflow-hidden position-relative">
                            {/* Top Badge Overlay */}
                            <div className="position-absolute top-0 end-0 m-3" style={{ zIndex: 2 }}>
                                <Badge bg="primary" className="px-3 py-2 rounded-pill shadow-sm bg-opacity-90 fw-medium" style={{ backgroundColor: '#4169e1' }}>
                                    <FaStar className="me-1 mb-1" size={11} /> {template.tag}
                                </Badge>
                            </div>

                            {/* Template Preview Image */}
                            <div className="template-image-wrapper overflow-hidden bg-light position-relative">
                                <Card.Img
                                    variant="top"
                                    src={template.image}
                                    alt={`${template.name} preview`}
                                    className="template-image"
                                />
                            </div>

                            <Card.Body className="d-flex flex-column p-4">
                                <div className="mb-2">
                                    <span className="text-muted small fw-medium d-block mb-1">
                                        <FaPalette className="me-1 text-primary" /> {template.category}
                                    </span>
                                    <Card.Title className="template-name text-dark fw-bold mb-3 fs-5">
                                        {template.name}
                                    </Card.Title>
                                </div>

                                <Button
                                    className="preview-btn mt-auto rounded-pill py-2.5 fw-semibold border-0 d-flex align-items-center justify-content-center gap-2 shadow-sm"
                                    onClick={() => setSelectedTemplate(template.name)}
                                    style={{ backgroundColor: '#4169e1' }}
                                >
                                    <FaEye size={15} />
                                    Preview Template
                                </Button>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>

            <Modal
                show={selectedTemplate !== null}
                onHide={() => setSelectedTemplate(null)}
                size="md"
                centered
            >
                <Modal.Header closeButton className="border-0">
                    <Modal.Title className="w-100 text-center fw-bold mt-3" style={{ color: '#4169e1', fontSize: '1.6rem', letterSpacing: '-0.5px' }}>
                        {selectedTemplate}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center px-4 pb-4">
                    <p style={{ fontSize: '1rem', color: '#475569', lineHeight: '1.6' }}>
                        We are currently designing and building gorgeous, interactive website templates for your special event.
                        This template feature will be available very soon!
                    </p>
                    <div style={{ fontSize: '2.5rem', margin: '15px 0' }}>🎨✨🚀</div>
                    <Button
                        onClick={() => setSelectedTemplate(null)}
                        style={{
                            backgroundColor: '#4169e1',
                            border: 'none',
                            borderRadius: '25px',
                            padding: '10px 30px',
                            fontWeight: '600',
                            marginTop: '10px',
                            boxShadow: '0 4px 12px rgba(65, 105, 225, 0.2)'
                        }}
                    >
                        Ok, I'll Wait
                    </Button>
                </Modal.Body>
            </Modal>
        </Container>
    );
};

export default WebsiteTemplates;